'use strict';

var React = require('react');

var SvgReadTimeMinor = function SvgReadTimeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 4h9v-.5a1.5 1.5 0 0 0-1.5-1.5h-7.5a3 3 0 0 0-3 3v11.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5h-.5v5l-2-2-2 2v-5h-4v-1a1 1 0 0 1 1-1z"
  }));
};

exports.SvgReadTimeMinor = SvgReadTimeMinor;
